/* eslint-disable */


import orderServiceStyles from '../../Services/Order/Order.service.styles';

/**
 * Create styles for `<OrderStatusGroup />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderStatusGroup />` styles
 */
const orderStatusGroupStyles = ({ theme }) => ({
  ...orderServiceStyles.chipStyles({ theme }),
  cardHeadAction: {
    marginBottom: 0,
    marginTop: 0,
  },
});

export default orderStatusGroupStyles;
